import React, { useState, useEffect, useMemo } from "react";
import { ArrowLeft, PlusCircle, Eye, Edit, Edit2, Trash2 } from "react-feather";
import { Link } from "react-router-dom";
import Table from "core/pagination/datatable";
import TableTop from "Components/UI/TableTop";
import { useTableSearch } from "core/Operations/useTableSearch";
import { useForm, FormProvider } from "react-hook-form";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { all_routes } from "Router/all_routes";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import Error404 from "MainPages/ErrorPages/error404";
import { foreignerLevyValidationSchema } from "core/Operations/ValidationSchema/MasterValidationSchema";
import { yupResolver } from "@hookform/resolvers/yup";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Popconfirm, Switch } from "antd";
import ToastNotification from "Components/UI/ToastNotification";
import {
  useForeignerlevyCategoriesQuery,
  useInsertForeignerlevyMutation,
  useDeleteForeignerlevyMutation,
  useUpdateForeignerlevyMutation,
} from "AppQuries/master/Foreignerlevy/foreignerlevy";

import ForeignerlevyModal from "Components/Modal/master/ForeignerlevyModal";
import { ToastProvider } from "Components/UI/ToastProvider";
import { toast } from "core/Operations/toast";
import { BackIcon } from "Components/UI/Icon/Icons";
import ReportTools from "Components/UI/ReportTools";
import Can from "core/Operations/Can";
import { accessCodes } from "core/json/accessCode";

const Foreignerlevy = () => {
  const userData = useSelector(loggedInUser);
  const [showActiveOnly, setShowActiveOnly] = useState(true);
  const [isMount, setIsMount] = useState(false);
  const {
    data,
    isLoading,
    isError,
    error,
    refetch: GetItems,
  } = useForeignerlevyCategoriesQuery(
    {
      companyCode: userData?.companyCode,
      isTrue: showActiveOnly,
    },
    {
      enabled: userData?.companyCode,
    }
  );
  const methods = useForm({
    resolver: yupResolver(foreignerLevyValidationSchema),
  });
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const { mutateAsync: insertForeignerlevy, isPending: isAdding } =
    useInsertForeignerlevyMutation();
  const { mutateAsync: updateForeignerlevy, isPending: isUpdating } =
    useUpdateForeignerlevyMutation();

  const { mutateAsync: deleteForeignerlevy, isPending: isDeleting } =
    useDeleteForeignerlevyMutation();
  const [selectedItem, setSelectedItem] = useState(null);

  const [show, setShow] = useState(false);
  const handleClose = () => {
    methods.reset();
    setShow(false);
  };
  const handleShow = () => setShow(true);

  const ItemData = Array.isArray(data)
    ? data?.map((d, _id) => ({
        id: _id + 1,
        ...d,
      }))
    : [];

  const handleAddClick = () => {
    setSelectedItem(null);
    methods.reset({
      companyCode: userData.companyCode,
      code: 0,
      foreignWorkerCode: "",
      description: "",
      monthlyAmount: "",
      dailyAmount: "",
      isActive: true,
      createUser: userData.userName,
      createDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    });
    setShow(true);
  };

  const handleEditClick = (item) => {
    setSelectedItem(item);
    methods.reset({
      companyCode: userData?.companyCode,
      code: item.code,
      foreignWorkerCode: item.foreignWorkerCode,
      description: item.description,
      monthlyAmount: item.monthlyAmount,
      dailyAmount: item.dailyAmount,
      isActive: item.isActive,
      createUser: item.createUser,
      createDate: item.createDate,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    });
    setShow(true);
  };

  const deleteItemHandler = (id) => {
    const payload = {
      companyCode: userData?.companyCode,
      code: id,
    };
    deleteForeignerlevy(payload, {
      onSuccess: (data) => {
        if (data) {
          toast.success("Item Deleted Successfully.");

          setSelectedItem(null);
          setShow(false);
          GetItems();
        } else {
          toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };

  const onSubmit = async (payload) => {
    try {
      if (selectedItem) {
        updateForeignerlevy(payload, {
          onSuccess: (data) => {
            console.log();
            if (data) {
              toast.success("Updated Successfully.");
              setSelectedItem(null);
              setShow(false);
              GetItems();
            } else {
              toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
            }
          },
          onError: (error) => {
            toast.error(error.message || "Something went wrong.");
          },
        });
      } else {
        insertForeignerlevy(payload, {
          onSuccess: (data) => {
            console.log(data);
            if (data) {
              toast.success("Added Successfully.");
              setShow(false);
              GetItems();
            } else {
              toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
            }
          },
          onError: (error) => {
            toast.error(error.message || "Something went wrong.");
          },
        });
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong.");
    }
  };

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = useMemo(() => [
    // { title: "S.no", dataIndex: "code", key: "code" },
    { title: "Description", dataIndex: "description", key: "description" },
    {
      title: "Monthly Amount",
      dataIndex: "monthlyAmount",
      key: "monthlyAmount",
    },
    { title: "Daily Amount", dataIndex: "dailyAmount", key: "dailyAmount" },

    {
      title: "Status",
      dataIndex: "isActive",
      render: (text, record) => (
        <>
          {text === true && (
            <div className="badges badge-linesuccess">Active</div>
          )}
          {text === false && (
            <div className="badges badge-linedanger">In Active</div>
          )}
        </>
      ),
    },

    {
      title: "Action",
      dataIndex: "action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>
          <Can
            accessModule={accessCodes.master}
            accessCode={accessCodes.master_foreignerLevy}
            accessType="haveEdit"
          >
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="add-new-tooltip">Edit</Tooltip>}
            >
              <Link
                className="me-2 p-2"
                onClick={() => handleEditClick(record)}
              >
                <Edit className="feather-edit" />
              </Link>
            </OverlayTrigger>
          </Can>
          <Can
            accessModule={accessCodes.master}
            accessCode={accessCodes.master_foreignerLevy}
            accessType="haveDelete"
          >
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="add-new-tooltip">Delete</Tooltip>}
            >
              <Link className="me-2 p-2" to="#">
                <Popconfirm
                  title="Are you sure to Delete?"
                  onConfirm={() => deleteItemHandler(record.code)}
                >
                  <Trash2 className="feather-delete" />
                </Popconfirm>
              </Link>
            </OverlayTrigger>
          </Can>
        </div>
      ),
    },
  ]);

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    ItemData,
    searchColumns
  );

  useEffect(() => {
    if (isMount) GetItems();

    setIsMount(true);
  }, [showActiveOnly]);

  if (isLoading || isAdding || isUpdating) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <Error404 error={error} />;
  }

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Forigner Levy</h4>
                <h6>Manage Forigner Levy Type</h6>
              </div>
            </div>
            <div className="page-btn">
              <ReportTools
                columns={columns}
                data={filteredData}
                fileName="Forigner Levy Master"
                isExcel={true}
                isPdf={true}
                pdfTheme="striped"
                refresh={GetItems}
              />
            </div>

            <div className="page-btn" style={{ display: "flex" }}>
              <Can
                accessModule={accessCodes.master}
                accessCode={accessCodes.master_foreignerLevy}
                accessType="haveAdd"
              >
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="add-new-tooltip">
                      Add New Forigner Levy Type
                    </Tooltip>
                  }
                >
                  <Link
                    to="#"
                    className="btn btn-added"
                    onClick={handleAddClick}
                  >
                    <PlusCircle className="me-2" />
                    Add
                  </Link>
                </OverlayTrigger>
              </Can>
              &nbsp;
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
              >
                <Link to={`${all_routes.master}`} className="btn btn-secondary">
                  <BackIcon className="me-2" />
                  Back
                </Link>
              </OverlayTrigger>
            </div>
          </div>

          <div className="card table-list-card border-0">
            <div className="card-body">
              <TableTop
                onSearch={setSearchValue}
                toggleFilterVisibility={toggleFilterVisibility}
                isFilterVisible={isFilterVisible}
                showToggle={false}
              />
              <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                // style={{ display: isFilterVisible ? "block" : "none" }}
              >
                <div className="card-body pb-0">
                  <div className="form-row row">
                    <div className="row">
                      <div className="col-lg-3 col-sm-6 col-12 mb-3">
                        <div className="form-group">
                          <Switch
                            checked={showActiveOnly}
                            checkedChildren="Show Active"
                            unCheckedChildren="Show All"
                            onChange={(checked) => setShowActiveOnly(checked)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="table-responsive">
                <Table
                  className="table  datanew"
                  columns={columns}
                  dataSource={filteredData}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <FormProvider {...methods}>
        <ForeignerlevyModal
          mode={selectedItem ? "E" : "I"}
          onSubmit={methods.handleSubmit(onSubmit)}
          show={show}
          handleClose={handleClose}
        />
      </FormProvider>
    </>
  );
};

export default Foreignerlevy;
